class CountryOverrideInterceptor {
  constructor() {
    this.country = null;

    this.intercept = this.intercept.bind(this);
  }

  setOverrideCountry(country) {
    this.country = country;
  }

  intercept(requestConfig) {
    const headers = requestConfig.headers || {};

    if (this.country) {
      headers[CountryOverrideInterceptor.COUNTRY_OVERRIDE_HEADER] =
        this.country;
    }

    return {
      ...requestConfig,
      headers,
    };
  }

  getInterceptor() {
    return this.intercept;
  }

  static get COUNTRY_OVERRIDE_HEADER() {
    return 'ETP-Viewer-Country-Override';
  }
}

const countryOverrideInterceptor = new CountryOverrideInterceptor();

export default countryOverrideInterceptor;
